



















































import { ItemDaVenda } from '@/models'
import { chaveDeNotaEhValida, emitenteDaChaveDeNota, normalizarChaveDeNota } from '@/shareds/fiscal'
import { VendaModule } from '@/store/vuex/venda/VendaStore'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { EditarUmaVendaUseCase } from '@/usecases'
import { Vue, Component, Ref, Watch } from 'vue-property-decorator'

const MSG_EMITENTE_DIVERGENTE = 'A nota informada precisa ter sido emitida pelo destinatário da devolução'

@Component
export default class DialogoDeInformarNotaDeOrigem extends Vue {
	@Ref() form!: HTMLFormElement

	mostra: boolean | null = false
	item: ItemDaVenda | null = null
	chaveInformada: string | null = null
	notaRules = [
		(v: any) => !!v || 'Campo obrigatório',
		(v: any) => this.chaveEstaNoFormatoEsperado(v) || this.mensagemDeChaveInvalida,
		(v: any) => this.emitenteConfereComDestinatario(v) || MSG_EMITENTE_DIVERGENTE,
	]
	loading = false

	editarUmaVendaUseCase = new EditarUmaVendaUseCase()

	mostrar(item: ItemDaVenda) {
		this.mostra = true
		this.item = item
	}

	fechar(){
		this.item = null
		this.mostra = false
	}

	get ehDevolucaoDeTransferencia() {
		return VendaModule.emissaoEntradaAtual?.tipoDeTransacao === 'Devolução de Transferência'
	}

	get mensagemDeChaveInvalida() {
		return this.ehDevolucaoDeTransferencia
			? 'A chave deve ter 44 dígitos, sem o prefixo NFe'
			: 'Informe uma chave válida'
	}

	chaveEstaNoFormatoEsperado(chave: string | null) {
		return this.ehDevolucaoDeTransferencia
			? chaveDeNotaEhValida(chave)
			: chave !== null && chave.length === 44
	}

	emitenteConfereComDestinatario(chave: string | null) {
		if (!this.ehDevolucaoDeTransferencia) return true
		if (!chaveDeNotaEhValida(chave)) return true

		const destinatario = (VendaModule.emissaoEntradaAtual?.cpfDoCliente || '').replace(/[^0-9]/g, '')
		if (destinatario.length !== 14) return true

		return emitenteDaChaveDeNota(chave) === destinatario
	}

	async informarNotaESerie() {
		if (!this.item) return
		if (!this.chaveEstaNoFormatoEsperado(this.chaveInformada)) {
			AlertModule.setError(this.mensagemDeChaveInvalida)
			return
		}
		if (!this.emitenteConfereComDestinatario(this.chaveInformada)) {
			AlertModule.setError(MSG_EMITENTE_DIVERGENTE)
			return
		}

		try {
			this.item.chaveNotaOrigem = this.ehDevolucaoDeTransferencia
				? normalizarChaveDeNota(this.chaveInformada)
				: this.chaveInformada

			this.$emit('incluirItemDeVenda', this.item)
		} catch(error) {
			AlertModule.setError(error)
		} finally {
			this.loading = false
			this.mostra = false
			this.chaveInformada = null
		}
	}

	@Watch('mostra')
	onChangeMostra(mostra: boolean, mostraAnterior: boolean) {
		if (mostra && !mostraAnterior) {
			window.requestAnimationFrame(() => {
				this.form.resetValidation()
			})
		}
	}

}
